import classes from "./GalleryViewer.module.css";
import SearchItem from "../../ui/SearchItem";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";


function GalleryViewer(props) {
  useEffect(() => {
    setCategories([...new Set(props.images.map((image) => image.category))]);
    setFilteredImages(props.images);
  }, [props.images]);

  const [categories, setCategories] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [model, setModel] = useState(false);
  const [modelImageSrc, setModelImageSrc] = useState("");

  const showModalImages = (imgSrc) => {
    setModelImageSrc(imgSrc);
    setModel(true);
  };

  const hideModalImages = () => {
    setModelImageSrc('');
    setModel(false);
  };

  function filterHandler(cat) {
    if (activeCategory === cat) {
      setActiveCategory(null);
      setFilteredImages(props.images);
    } else {
      setActiveCategory(cat);
      setFilteredImages(props.images.filter(img => img.category === cat));
    }
  }

  return (
    <>
      {model && (
        <div className={classes.modalOverlay} onClick={hideModalImages}>
          <div className={classes.modalContent} onClick={e => e.stopPropagation()}>
            <button className={classes.closeBtn} onClick={hideModalImages} aria-label="Close">
              <FontAwesomeIcon icon={faClose} />
            </button>
            <img src={modelImageSrc} className={classes.modalImg} alt="Gallery" />
          </div>
        </div>
      )}

      <div className={classes.pageWrapper}>
        <div className={classes.pageHeader}>
          <h1>Gallery</h1>
        </div>

        <div className={classes.schWrp}>
          {categories.map((cat, index) => (
            <SearchItem
              key={index}
              index={index}
              category={cat}
              active={activeCategory === cat}
              handleClick={() => filterHandler(cat)}
            />
          ))}
        </div>

        <div className={classes.galleryGrid}>
          {filteredImages.map((item, index) => (
            <div
              key={index}
              className={classes.galleryThumb}
              style={{ backgroundImage: `url(${item.image})` }}
              onClick={() => showModalImages(item.image)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default GalleryViewer;
